// Generate realistic mock data
const generateRealtimeData = () => {
  const now = new Date();
  return Array.from({ length: 20 }, (_, i) => ({
    time: new Date(now - (19 - i) * 60000).toLocaleTimeString('en-US', {
      hour: '2-digit',
      minute: '2-digit'
    }),
    value: 15000 + Math.random() * 10000
  }));
};

export const liveMetrics = {
  todaySales: 1458932,
  activeStores: 94,
  totalStores: 100,
  realtimeData: generateRealtimeData(),
  peakHour: {
    time: '13:00',
    sales: 42891
  }
};

// Generate comparison data for different time periods
const generateComparisonData = () => {
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(yesterday.getDate() - 1);
  
  const lastWeek = new Date(today);
  lastWeek.setDate(lastWeek.getDate() - 7);
  
  const lastMonth = new Date(today);
  lastMonth.setMonth(lastMonth.getMonth() - 1);
  
  const lastYear = new Date(today);
  lastYear.setFullYear(lastYear.getFullYear() - 1);
  
  // Generate daily data for detailed comparisons
  const dailyData = [];
  for (let i = 0; i < 24; i++) {
    // Current period (today)
    const current = {
      hour: i,
      timeLabel: `${i}:00`,
      sales: Math.round(50000 + Math.random() * 150000),
      transactions: Math.round(200 + Math.random() * 800),
      customers: Math.round(180 + Math.random() * 700),
      avgTicket: Math.round(80 + Math.random() * 70),
      conversion: Math.round(40 + Math.random() * 50),
      unitsPerTransaction: Math.round(1 + Math.random() * 4 * 10) / 10,
      trafficCount: Math.round(250 + Math.random() * 1000),
      staffCount: Math.round(3 + Math.random() * 7)
    };
    
    // Previous period (yesterday)
    const previous = {
      hour: i,
      timeLabel: `${i}:00`,
      sales: Math.round(current.sales * (0.7 + Math.random() * 0.6)),
      transactions: Math.round(current.transactions * (0.7 + Math.random() * 0.6)),
      customers: Math.round(current.customers * (0.7 + Math.random() * 0.6)),
      avgTicket: Math.round(current.avgTicket * (0.8 + Math.random() * 0.4)),
      conversion: Math.round(current.conversion * (0.8 + Math.random() * 0.4)),
      unitsPerTransaction: Math.round(current.unitsPerTransaction * (0.8 + Math.random() * 0.4) * 10) / 10,
      trafficCount: Math.round(current.trafficCount * (0.7 + Math.random() * 0.6)),
      staffCount: Math.round(current.staffCount * (0.8 + Math.random() * 0.4))
    };
    
    dailyData.push({
      hour: i,
      timeLabel: `${i}:00`,
      current,
      previous
    });
  }
  
  return {
    periods: {
      today: {
        date: today.toLocaleDateString(),
        sales: 1458932,
        transactions: 12567,
        customers: 10982,
        avgTicket: 116.09,
        conversion: 45.2,
        unitsPerTransaction: 2.4,
        trafficCount: 24296,
        staffCount: 87,
        baskets: 12567,
        returnRate: 8.3,
        newCustomers: 2534,
        salesPerSqMeter: 342.5,
        salesPerStaffHour: 1674.63
      },
      yesterday: {
        date: yesterday.toLocaleDateString(),
        sales: 1287654,
        transactions: 11234,
        customers: 9876,
        avgTicket: 114.62,
        conversion: 43.8,
        unitsPerTransaction: 2.3,
        trafficCount: 22548,
        staffCount: 85,
        baskets: 11234,
        returnRate: 7.9,
        newCustomers: 2187,
        salesPerSqMeter: 301.8,
        salesPerStaffHour: 1514.89
      },
      lastWeekSameDay: {
        date: lastWeek.toLocaleDateString(),
        sales: 1367542,
        transactions: 11987,
        customers: 10432,
        avgTicket: 114.08,
        conversion: 44.5,
        unitsPerTransaction: 2.3,
        trafficCount: 23443,
        staffCount: 86,
        baskets: 11987,
        returnRate: 8.1,
        newCustomers: 2298,
        salesPerSqMeter: 320.36,
        salesPerStaffHour: 1589.0
      },
      lastMonthSameDay: {
        date: lastMonth.toLocaleDateString(),
        sales: 1298754,
        transactions: 11456,
        customers: 9987,
        avgTicket: 113.37,
        conversion: 42.9,
        unitsPerTransaction: 2.2,
        trafficCount: 23279,
        staffCount: 84,
        baskets: 11456,
        returnRate: 7.7,
        newCustomers: 2187,
        salesPerSqMeter: 304.18,
        salesPerStaffHour: 1546.14
      },
      lastYearSameDay: {
        date: lastYear.toLocaleDateString(),
        sales: 1198342,
        transactions: 10876,
        customers: 9456,
        avgTicket: 110.18,
        conversion: 41.8,
        unitsPerTransaction: 2.1,
        trafficCount: 22622,
        staffCount: 82,
        baskets: 10876,
        returnRate: 7.4,
        newCustomers: 2087,
        salesPerSqMeter: 280.72,
        salesPerStaffHour: 1461.39
      }
    },
    hourlyData: dailyData,
    metrics: [
      { id: 'sales', name: 'Sales', format: 'currency', color: '#3B82F6' },
      { id: 'transactions', name: 'Transactions', format: 'number', color: '#10B981' },
      { id: 'customers', name: 'Customers', format: 'number', color: '#8B5CF6' },
      { id: 'avgTicket', name: 'Avg Ticket', format: 'currency', color: '#F59E0B' },
      { id: 'conversion', name: 'Conversion Rate', format: 'percent', color: '#EC4899' },
      { id: 'unitsPerTransaction', name: 'Units per Transaction', format: 'decimal', color: '#6366F1' },
      { id: 'trafficCount', name: 'Traffic Count', format: 'number', color: '#EF4444' },
      { id: 'staffCount', name: 'Staff Count', format: 'number', color: '#14B8A6' },
      { id: 'baskets', name: 'Baskets', format: 'number', color: '#F97316' },
      { id: 'returnRate', name: 'Return Rate', format: 'percent', color: '#06B6D4' },
      { id: 'newCustomers', name: 'New Customers', format: 'number', color: '#8B5CF6' },
      { id: 'salesPerSqMeter', name: 'Sales per m²', format: 'currency', color: '#D946EF' },
      { id: 'salesPerStaffHour', name: 'Sales per Staff Hour', format: 'currency', color: '#0EA5E9' }
    ]
  };
};

export const comparisonData = generateComparisonData();

export const topPerformers = [
  {
    id: 1,
    name: 'Riyadh Gallery',
    location: 'Riyadh',
    sales: 892450,
    growth: 15.8
  },
  {
    id: 2,
    name: 'Red Sea Mall',
    location: 'Jeddah',
    sales: 784120,
    growth: 12.4
  },
  {
    id: 3,
    name: 'Dhahran Mall',
    location: 'Dhahran',
    sales: 682340,
    growth: 9.2
  },
  {
    id: 4,
    name: 'Al Nakheel Mall',
    location: 'Riyadh',
    sales: 578900,
    growth: 8.7
  },
  {
    id: 5,
    name: 'Al Rashid Mall',
    location: 'Dammam',
    sales: 492780,
    growth: 7.5
  }
];

// Saudi Arabia regions with detailed data
export const regions = [
  {
    id: 'riyadh',
    name: 'Riyadh Region',
    center: [24.7136, 46.6753],
    totalSales: 2450000000,
    storeCount: 28,
    growth: 15.2,
    stores: [
      {
        id: 'RYD01',
        name: 'Riyadh Gallery',
        coordinates: [24.7741, 46.7267],
        sales: 892450,
        growth: 15.8
      },
      {
        id: 'RYD02',
        name: 'Kingdom Centre',
        coordinates: [24.7112, 46.6743],
        sales: 756320,
        growth: 12.3
      },
      {
        id: 'RYD03',
        name: 'Al Nakheel Mall',
        coordinates: [24.7685, 46.6943],
        sales: 578900,
        growth: 8.7
      },
      {
        id: 'RYD04',
        name: 'Panorama Mall',
        coordinates: [24.7023, 46.7844],
        sales: 534200,
        growth: 9.2
      },
      // ... more Riyadh stores
    ]
  },
  {
    id: 'eastern',
    name: 'Eastern Province',
    center: [26.3927, 50.1810],
    totalSales: 1950000000,
    storeCount: 25,
    growth: 11.8,
    stores: [
      {
        id: 'DMM01',
        name: 'Al Rashid Mall',
        coordinates: [26.4207, 50.0887],
        sales: 492780,
        growth: 7.5
      },
      {
        id: 'KHB01',
        name: 'Mall of Dhahran',
        coordinates: [26.3064, 50.2246],
        sales: 682340,
        growth: 9.2
      },
      {
        id: 'DMM02',
        name: 'Dammam Plaza',
        coordinates: [26.4312, 50.1142],
        sales: 445600,
        growth: 6.8
      },
      // ... more Eastern Province stores
    ]
  },
  {
    id: 'makkah',
    name: 'Makkah Region',
    center: [21.5433, 39.1728],
    totalSales: 1850000000,
    storeCount: 22,
    growth: 12.4,
    stores: [
      {
        id: 'JED01',
        name: 'Red Sea Mall',
        coordinates: [21.6325, 39.1362],
        sales: 784120,
        growth: 12.4
      },
      {
        id: 'JED02',
        name: 'Mall of Arabia',
        coordinates: [21.6631, 39.1122],
        sales: 654300,
        growth: 10.2
      },
      {
        id: 'MKH01',
        name: 'Makkah Mall',
        coordinates: [21.4225, 39.8262],
        sales: 623400,
        growth: 11.5
      },
      // ... more Makkah region stores
    ]
  },
  {
    id: 'tabuk',
    name: 'Tabuk Region',
    center: [28.3835, 36.5662],
    totalSales: 850000000,
    storeCount: 8,
    growth: 9.5,
    stores: [
      {
        id: 'TBK01',
        name: 'Tabuk Park',
        coordinates: [28.3998, 36.5714],
        sales: 285600,
        growth: 8.4
      },
      // Add more Tabuk stores...
    ]
  },
  {
    id: 'hail',
    name: "Ha'il Region",
    center: [27.5114, 41.7208],
    totalSales: 720000000,
    storeCount: 6,
    growth: 8.9,
    stores: [
      {
        id: 'HAL01',
        name: 'Hail Square Mall',
        coordinates: [27.5242, 41.6957],
        sales: 245800,
        growth: 7.8
      },
      // Add more Hail stores...
    ]
  },
  {
    id: 'asir',
    name: 'Asir Region',
    center: [18.2164, 42.5053],
    totalSales: 980000000,
    storeCount: 12,
    growth: 10.2,
    stores: [
      {
        id: 'ABH01',
        name: 'Abha Mall',
        coordinates: [18.2147, 42.5052],
        sales: 324500,
        growth: 9.6
      },
      // Add more Asir stores...
    ]
  }
  // ... Add more regions
];

export const salesTrends = {
  daily: Array.from({ length: 30 }, (_, i) => ({
    date: new Date(Date.now() - (29 - i) * 24 * 60 * 60 * 1000),
    sales: 15000000 + Math.random() * 5000000,
    transactions: 125000 + Math.random() * 25000,
    avgTicket: 120 + Math.random() * 20
  })),
  
  weekly: Array.from({ length: 52 }, (_, i) => ({
    week: i + 1,
    sales: 105000000 + Math.random() * 25000000,
    transactions: 875000 + Math.random() * 125000,
    avgTicket: 120 + Math.random() * 20
  })),
  
  monthly: Array.from({ length: 12 }, (_, i) => ({
    month: new Date(2024, i, 1).toLocaleString('default', { month: 'short' }),
    sales: 450000000 + Math.random() * 100000000,
    transactions: 3750000 + Math.random() * 500000,
    avgTicket: 120 + Math.random() * 20
  }))
};

export const performanceRankings = {
  regionalManagers: [
    {
      id: 1,
      name: 'Ahmed Al-Saud',
      region: 'Riyadh Region',
      sales: 2450000000,
      yoyGrowth: 15.2,
      performance: 98.5,
      photo: 'https://example.com/photo1.jpg'
    },
    // Add more managers...
  ],
  
  districtManagers: [
    {
      id: 1,
      name: 'Mohammed Al-Qahtani',
      district: 'North Riyadh',
      sales: 980000000,
      yoyGrowth: 18.5,
      performance: 97.8,
      photo: 'https://example.com/photo2.jpg'
    },
    // Add more managers...
  ],
  
  storeManagers: [
    {
      id: 1,
      name: 'Sara Al-Rashid',
      store: 'Riyadh Gallery',
      sales: 156000000,
      yoyGrowth: 22.4,
      performance: 99.2,
      photo: 'https://example.com/photo3.jpg'
    },
    // Add more managers...
  ]
};

// Add more mock data structures... 